import React, {createContext, useEffect, useState} from "react";
import {getAuthToken} from "./AuthService";

interface AuthContextType {
    token: string | null;
    setToken: (token: string) => void;
}

interface AuthProviderProps {
    children: React.ReactNode;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<AuthProviderProps> = function ({
                                                                       children,
                                                                   }) {
    const [token, setToken] = useState<string | null>(getAuthToken());

    useEffect(() => {
        const authToken = getAuthToken();
        if (authToken !== token) {
            setToken(authToken);
        }
    }, [token]);

    return (
        <AuthContext.Provider value={{token, setToken}}>
            {children}
        </AuthContext.Provider>
    );
};